var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgC = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 157 68"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M157 43a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h3.278c1.562 0 2.823-1.218 3.304-2.703C11.143 49.482 15.665 46 21 46c1.842 0 3.586.415 5.145 1.156 2.692 1.28 10.018 1.28 12.71 0A11.95 11.95 0 0 1 44 46c5.335 0 9.857 3.482 11.418 8.297C55.899 55.782 57.16 57 58.722 57h67.556c1.562 0 2.823-1.218 3.304-2.703C131.143 49.482 135.665 46 141 46c5.624 0 10.344 3.869 11.645 9.09.264 1.062 1.156 1.91 2.251 1.91A2.104 2.104 0 0 0 157 54.896z",
  clipRule: "evenodd"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 119,
  height: 37,
  x: 1,
  fill: "#000",
  rx: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M129 0a3 3 0 0 0-3 3v40a3 3 0 0 0 3 3h25a3 3 0 0 0 3-3V22.884c0-.324-.052-.646-.155-.953l-6.659-19.884A3 3 0 0 0 147.341 0zm4 4a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h15.759c2.07 0 3.518-2.047 2.829-3.999l-4.59-13A3 3 0 0 0 144.169 4zM21 68c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10m0-4a6 6 0 1 0 0-12 6 6 0 0 0 0 12M44 68c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10m0-4a6 6 0 1 0 0-12 6 6 0 0 0 0 12M141 68c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10m0-4a6 6 0 1 0 0-12 6 6 0 0 0 0 12",
  clipRule: "evenodd"
})));
export default SvgC;